import './MapModeButton.css';

export type MapMode = 'city' | 'follow';

interface Props {
  mode: MapMode;
  onCycle: () => void;
}

export function MapModeButton({ mode, onCycle }: Props) {
  return (
    <button
      type="button"
      className={`mode-btn mode-btn-${mode}`}
      aria-label={`Camera mode: ${mode}`}
      onClick={onCycle}
    >
      <ModeIcon mode={mode} />
    </button>
  );
}

function ModeIcon({ mode }: { mode: MapMode }) {
  if (mode === 'city') {
    // Hexagon — represents a city boundary fitted to view
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2 4 6.5v11L12 22l8-4.5v-11z" />
        <circle cx="12" cy="12" r="2" fill="currentColor" stroke="none" />
      </svg>
    );
  }
  // follow
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="3" fill="currentColor" stroke="none" />
      <path d="M12 1v3M12 20v3M1 12h3M20 12h3" />
    </svg>
  );
}
